import { GridListSelectable } from 'breeze-intelligence-kit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EnrichmentPropertiesRow } from './EnrichmentPropertiesRow';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichmentPropertiesTable({
  onSelect,
  properties = [],
  selectedProperties = []
}) {
  const {
    isIncludedEnrichment
  } = useEnrichmentCredits();
  const items = properties.map(property => property.name);
  return /*#__PURE__*/_jsxs(GridListSelectable, {
    items: items,
    onSelect: onSelect,
    overflow: "visible",
    selectedItems: selectedProperties,
    children: [/*#__PURE__*/_jsx(GridListSelectable.Header, {
      children: /*#__PURE__*/_jsxs(GridListSelectable.RowSelectAll, {
        children: [/*#__PURE__*/_jsx(GridListSelectable.HeaderItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.table.columns.name"
          })
        }), /*#__PURE__*/_jsx(GridListSelectable.HeaderItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.table.columns.value"
          })
        }), isIncludedEnrichment && /*#__PURE__*/_jsx(GridListSelectable.HeaderItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.table.columns.enrichedValue"
          })
        }), /*#__PURE__*/_jsx(GridListSelectable.HeaderItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.table.columns.source"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(GridListSelectable.Body, {
      children: properties.map(property => /*#__PURE__*/_jsx(EnrichmentPropertiesRow, {
        property: property
      }, property.name))
    })]
  });
}